import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import api from "../../system/api";

export default class UserAccess extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "user-role";
    static pluralName = "user-roles";
    static displayName = "UserRoles";

    constructor() {
        super(`${UserAccess.kind}`,`${UserAccess.singularName}`,`${UserAccess.pluralName}`);}

    async getAll(query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.fetch(_query);
    }


    async getById(id, query = {}) {
        return await this.find(id, { populate: "*", ...query });
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data) {
        return await this.update(id, data);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }

    async getWorkspaceAccessRoles() {
        return await this.action("", "/workspace-access-roles");
    }

    async getScopedAccessRoles(scopeType, scopeId) {
        return await this.action("", `/scoped-access-roles/${encodeURIComponent(scopeType)}/${encodeURIComponent(scopeId)}`);
    }

    async promoteWorkspaceAdmin(workspaceMembershipId, permissions = []) {
        return await this.postAction("/workspace-access-roles/admins", {
            workspace_membership: workspaceMembershipId,
            permissions,
        });
    }

    async updateWorkspaceAdmin(documentId, permissions = []) {
        return await this.putAction(`/workspace-access-roles/admins/${documentId}`, {permissions});
    }

    async demoteWorkspaceAdmin(documentId) {
        try {
            await this.waitForWorkspace();
            const response = await api.delete(
                `/workspace-access-roles/admins/${documentId}`,
                this.getHeader(),
            );
            return response.data;
        } catch (error) {
            throw this._normalizeError(error);
        }
    }
}
